import React, { useCallback, useRef } from 'react';
import { Flex } from '@banhala/ui-kit';
import { type LayoutChangeEvent } from 'react-native';

export const SectionContainer = React.memo(
  (props: {
    children: React.ReactElement<{ isSkeleton: boolean }>;
    height?: number;
    sectionKey: string;
    onChangeHeight: (key: string, height: number) => void;
  }) => {
    const { onChangeHeight, sectionKey } = props;
    const heightRef = useRef(0);

    const handleLayout = useCallback(
      ({ nativeEvent }: LayoutChangeEvent) => {
        const nextHeight = Math.round(nativeEvent.layout.height);
        if (heightRef.current !== nextHeight) {
          heightRef.current = nextHeight;
          onChangeHeight(sectionKey, nextHeight);
        }
      },
      [onChangeHeight, sectionKey],
    );

    return (
      <Flex height={props.height} onLayout={handleLayout}>
        {props.children}
      </Flex>
    );
  },
);
